import React from 'react'
import '../container.css'
import resim1 from './images/foto1.jpg'
import resim2 from './images/foto2.jpg'
import resim3 from './images/foto3.jpg'
import resim4 from './images/foto4.jpg'
import resim5 from './images/foto5.jpg'
import resim6 from './images/foto6.jpg'
import resim7 from './images/foto7.jpg'
import resim8 from './images/foto8.jpg'
import resim9 from './images/foto9.jpg'
import resim10 from './images/foto10.jpg'
import resim11 from './images/foto11.jpg'
import resim12 from './images/foto12.jpg'
import resim13 from './images/foto13.jpg'
import resim14 from './images/foto14.jpg'


const BizKimiz = () => {
    return (
        <div className="info-pages-container">
            <h1>Biz Kimiz?</h1>
            <br></br>
            <p>Bu proje Doğa Koruma Merkezi’nin desteği, gönüllülerin emekleri ve ODTÜ BÖTE Bölümünün katkılarıyla hazırlanmıştır.</p>
            <br></br>
            <h2>ODTÜ Flora Projesi ve Flora Grubu</h2>
            <br></br>

            <div>
                <img src={resim12}></img>
            </div>
            <h3><b>Fethiye Arslantaş</b></h3>
            <p style={{ textAlign: "center" }}><i>Haritaların hazırlanması, arazi çalışması, herbaryum örneklerinin hazırlanması</i></p>
            <p>ODTÜ’de şehir ve bölge planlama okudum. Doğa koruma ile ilgili çalışmalara merak sarmamda kampüsün benim için önemli bir yeri var. Öğrenmenin, amfiler ve sınıfların ötesinde olduğunu ODTÜ’nün doğasında keşfettim. Bozkıra, ormana ve göle yaptığımız arazilerde, farklı mevsimlerde farklı renkleri bulmak çok heyecan verici!</p>
            <br></br>

            <div>
                <img src={resim1}></img>
            </div>
            <h3><b>Gözde Atağ</b></h3>
            <p style={{ textAlign: "center" }}><i>Arazi çalışması, herbaryum örneklerinin hazırlanması</i></p>
            <p>ODTÜ'de biyoloji okuyorum. Yaklaşık iki senedir doğa rehberliği yapıyorum. Doğayla iç içe yetişmenin bana kattığı değerler doğrultusunda inanıyorum ki her birimiz doğanın bir parçasıyız ve onu korumakla yükümlüyüz. Bunun yalnızca bilim camiasınca değil toplum tarafından da benimsenmesi gerektiğini düşünüyor ve benimsediğim bu hedef doğrultusunda adımlar atıyor, her birinden keyif alıyorum.</p>
            <br></br>

            <div>
                <img src={resim2}></img>
            </div>
            <h3><b>Can Bilgin</b></h3>
            <p style={{ textAlign: "center" }}><i>Arazi çalışmaları, kampüs ekolojisi</i></p>
            <p>Ekoloji hem uzmanlık alanı hem de hobi olarak en ilgimi çeken konudur. Aslında uzmanlık alanım daha çok zooloji, özellikle de kuşlar ve büyük memeliler olmasına rağmen söz konusu ODTU Kampüsü ve arazi çalışması olunca, bitkiler için de olsa bu çalışmanın dışında kalamadım. Benim için en keyifli kısmı da Mecit Hoca ve Uğur ile arazi çalışması yapıp, türlerin dağılımı ve kompozisyonu ile ilgili ekolojik tartışmalar yapmak oldu. </p>
            <br></br>

            <div>
                <img src={resim4}></img>
            </div>
            <h3><b>Zeyneb Vildan Çakıl</b></h3>
            <p style={{ textAlign: "center" }}><i>Arazi çalışması, herbaryum örneklerinin hazırlanması</i></p>
            <p>Zeyneb Vildan ODTÜ Moleküler Biyoloji ve Genetik'ten yeni mezun oldu. Doğayla akademik hayatı moleküler düzeyde devam etse de doğayı tanımayı ve tanıtmayı sorumluluk edindi.</p>


            <div>
                <img src={resim3}></img>
            </div>
            <h3><b>Barış Çalışkan</b></h3>
            <p style={{ textAlign: "center" }}><i>Arazi çalışması, herbaryum örneklerinin hazırlanması</i></p>
            <p>Merhaba ben Barış. Çocukluğumda ağaçlara tırmanma, toprakla oynama, böceklerle yakınlaşma imkânı bulduğumdan beri, o günkü merak ve heyecanımla hep doğanın içinde buldum kendimi. Bugün de Ankara’nın ve ODTÜ’nün ormanlarında, göllerinde ve bozkırlarında bir doğa rehberi olarak gerek yalnız gerek başka insanlarla geziyor, öğreniyor ve doğadan edindiğim bilgileri paylaşıyorum. Bu projede yer almak, destek vermek de büyük bir zevkti.</p>
            <br></br>

            <div>
                <img src={resim13}></img>
            </div>
            <h3><b>Gökhan Eryılmaz</b></h3>
            <p style={{ textAlign: "center" }}><i>Web sitesinin hazırlanması, kodların yazımı, arayüzlerin üretilmesi</i></p>
            <p>Bir ODTÜ mensubu olarak üniversite hayatım boyunca doğa ile iç içe bir ortamda yaşama lüksüne eriştim. ODTÜ'den uzak olduğum günlerde hep ormanın temiz havasını içime çekmek arzusu duydum.</p>
            <br></br>

            <div>
                <img src={resim10}></img>
            </div>
            <h3><b>M. Banu Gündoğan</b></h3>
            <p style={{ textAlign: "center" }}><i>Arazi çalışması, web sitesinin tasarımı</i></p>
            <p>1981 yılından beri ODTÜ doğası ile iç içeyim. 1986 yılından beri de doğa ve bilim eğitimini toplumun her kesimine ulaştıracak etkinlikler tasarlıyorum ve gönüllü ekiplerle uyguluyorum. Teknolojiyi de bu etkinliklerin bir parçası olarak kullanmayı seviyorum.</p>
            <br></br>

            <div>
                <img src={resim5}></img>
            </div>
            <h3><b>Umut Hasanoğlu</b></h3>
            <p style={{ textAlign: "center" }}><i>Arazi çalışması, herbaryum örneklerinin hazırlanması, bitki teşhis çalışmaları</i></p>
            <p>ODTÜ’de biyoloji okuyorum. Doğa gezilerini, bisiklet sürmeyi ve birlikte üretim
yapmayı severim. Çocukluğumdan beri ağaç tepelerinde dolanmaktan kendimi
alamam. Doğaya, özellikle de bitkilere ilgim var. Öğrenmek ve öğretmekten çok
hoşlanırım. Gönüllü olarak çiftliklerde organik tarım ve doğal mimari üzerine
çalışmalarda bulundum, bunun yanında ODTÜ kampüsü içerisinde ağaç tanıma
gezileri ve doğa eğitimlerinde kolaylaştırıcılık yaptım. Doğal üretimler yaparım;
sirke, şarap, marmelat, reçel, merhem, bitki çayları. 2017 Ağustos’unda
katıldığım, İtalya’nın Damanhur Ekoköyünde gerçekleşen bir aylık Ekoköy
Tasarım Kursu hayatımı değiştirdi ve beni sürdürülebilirlik ve doğa bilinci
konularıyla daha fazla uğraşmaya itti. Hayatımın bu noktasında öğrenmek ve
öğrendiklerimi öğretmek, herkesle birlikte üretmek istiyorum. Ve biliyorum ki bir
insan ne kadar uğraşırsa uğraşsın karşısındakinin istediği kadar öğretebilir.
Doğaya merakla bakan bir insanı hiçbir şey öğrenmekten alıkoyamaz. Bu yüzden
insanlarda doğaya ve canlılara dair merak kıvılcımları uyandırmaya çalışıyorum.</p>
            <br></br>

            <div>
                <img src={resim6}></img>
            </div>
            <h3><b>Halime Karatoprak</b></h3>
            <p style={{ textAlign: "center" }}><i>Arazi çalışması, herbaryum örneklerinin hazırlanması</i></p>
            <p>Ben Halime, ODTÜ Biyoloji 3.Sınıf öğrencisiyim. Küçüklüğümden beri doğa benim için tümüyle ilham kaynağı oldu. Anda kalmayı, doğayı hissetmeyi, kuş cıvıltılarını ve kelebek danslarını, doğadaki tüm ahengi, rengi severim. Bu yüzden doğayı küçük bir çocuk gibi merak eder, minik ayrıntılarına takılırım. Doğada geçirdiğim zamanlar da uygulamalı ve kalıcı olsun isterim. Öğrenebildiğim her şeyi aktarabilmek, bir zincirin parçası olmak benim için değerli şeylerden ve bu yüzden gönüllü doğa rehberleri takımının bir parçası olmaktan çok memnunum. Doğa keşif gezileri, oyunlar, atölyeler ve doğayla ilgili her şey benden bir parça şeyler. Evrene bir şeyler verebileceğime ve onun da bana sınırsız güzelliklerinden göz kırpacağına inanırım.</p>
            <br></br>

            <div>
                <img src={resim11}></img>
            </div>
            <h3><b>Mustafa Mallı</b></h3>
            <p style={{ textAlign: "center" }}><i>CEIT 436 dersi kapsamında Web-sitesinin hazırlanması, kodların yazımı, arayüzlerin üretilmesi</i></p>
            <p>ODTÜ Bilgisayar ve Öğretim Teknolojileri Eğitimi son sınıf öğrencisiyim. ODTÜ’ye girdiğim 2014 senesinden beri doğayı, özellikle de ODTÜ’nün bitki örtüsünü sevdiğimden dolayı kampüs içinde gideceğim yerlere çok nadiren ring veya otostop ile gider ve genelde yürüyerek ODTÜ doğasının tadını çıkartırım.</p>
            <br></br>
            
            <div>
                <img src={resim14}></img>
            </div>
            <h3><b>Melek Mercantaş</b></h3>
            <p>ODTÜ Çevre Mühendisliği bölümü mezunuyum ve yine ODTÜ Yer Sistem Bilimleri bölümünde öğrenciyim.  Spor yapmayı ve uzun yürüyüşleri çok severim. ODTÜ&#39;nün doğasıyla 2011 yılında tanıştım. Daha önceleri sadece vakit geçirmekten çok hoşlandığım bir ormanlık alan ve kampüs alanıyken, bugün hangi kuşun öttüğünden, hangi çiçeğin açtığına kadar merak ettiğim; bir hafta gitmesem diğer hafta özlediğim bir ev oldu benim için.  Şimdi de arazi içinde çeşit çeşit, renk renk bitkiler keşfederken çok keyif alıyorum.</p>
            <p style={{ textAlign: "center" }}><i>Arazi çalışması, herbaryum örneklerinin hazırlanması</i></p>
            <br></br>

            <div>
                <img src={resim7}></img>
            </div>
            <h3><b>Nurbahar Usta</b></h3>
            <p style={{ textAlign: "center" }}><i>Arazi çalışması, herbaryum örneklerinin hazırlanması, bitki listesinin üretilmesi, bitkilerin renk ve çiçek şekillerine göre gruplandırılması</i></p>
            <p>Yıldız Teknik Üniversitesi Biyomühendislik Bölümü lisans ve ODTÜ Biyoloji yüksek lisans mezunuyum. Güncel olarak Hacettepe Üniversitesi, Biyoloji Bölümü, Ekoloji Anabilim Dalı’nda doktora çalışmalarımı sürdürmekteyim. İklim değişikliğinin genel olarak bitki türlerinin dağılımı ve ekosistem dinamikleri üzerine etkisini incelemeye çalışıyorum. Doğa korumanın yalnızca ekolojik araştırmalar yürütmekle mümkün olmadığını düşündüğümden, çalışmalarımın toplumsal uygulanabilirliğinin olmasını hedefliyorum. Odaklandığım bölge şimdilik Kazdağları gibi gözüküyor. Diğer yandan amatör olarak kuş ve bitki gözlemi yapmayı sürdürüyorum. Bozkır Kitaplığı isimli kitap kulübünün ve Ekoloji ve Evrimsel Biyoloji Derneği’nin hevesli bir üyesiyim.</p>
            <br></br>

            <div>
                <img src={resim8}></img>
            </div>
            <h3><b>Mecit Vural</b></h3>
            <p style={{ textAlign: "center" }}><i>Bitkilerin teşhisi, botanik danışmanlık, arazi çalışması</i></p>
            <p>Benim uzmanlık alanım sistematik botanik, yani bitkileri tanımlamak. Gazi Üniversitesi’nden emekli olduğumdan beri ODTÜ Doğa Rehberleri, Uğur ve Can ile beraber ODTÜ Kampüsünde botanik gezileri yapıyoruz. Bu aralar 100’e yakın botanikçi arkadaşla beraber, bir yandan Türkiye Bitkilerinin Kırmızı Listesi’ni hazırlarken, diğer yandan da Türkçe olarak resimli Türkiye Florasını yazmaya çalışıyoruz.</p>
            <br></br>
           
            <div>
                <img src={resim9}></img>
            </div>
            <h3><b>Uğur Zeydanlı</b></h3>
            <p style={{ textAlign: "center" }}><i>Çalışmaların koordinasyonu, arazi çalışması, bitkilerin teşhisi</i></p>
            <p>ODTÜ kampüsünde dolaşıp, bitkilerin fotoğrafını çekmek, onları tanımaya çalışmak en sevdiğim şeylerden biri. 1993 yılından beri bunu yapıyorum. Bunun dışındaki zamanlarda da doğa koruma ile ilgili çalışmalar yapıyorum, Yer Bilimleri Programı ve Şehir Bölge Planlama Bölümü’nde bu konularla ilgili ders veriyorum. Ama en güzeli doğada dolaşmak.</p>
            <br></br>

        </div>
    )
}

export default BizKimiz